import { memo } from "react";
import { SettlementData } from "../utils/settlementCalculator";

interface SettlementCardProps {
  settlementData: SettlementData;
  getBudgetGroupName: (groupId: string) => string | null;
  getUserFriendlyName: (budgetGroup: string | undefined, userId: string) => string | null;
}

export const SettlementCard = memo(({
  settlementData,
  getBudgetGroupName,
  getUserFriendlyName
}: SettlementCardProps) => {
  if (settlementData.netBalances.length === 0) return null;

  return (
    <div className="settlement-card">
      <div className="settlement-header">
        <h3>Balances for {getBudgetGroupName(settlementData.selectedGroupId)}</h3>
      </div>
      <div className="settlement-list">
        {settlementData.netBalances.map((balance, index) => (
          <div key={index} className={`settlement-item ${balance.isOwed ? 'is-owed' : 'owes'}`}>
            <span className="settlement-name">
              {getUserFriendlyName(settlementData.selectedGroupId, balance.userId) || balance.userId}
            </span>
            <span className="settlement-status">
              {balance.isOwed ? 'is owed' : 'owes'}
            </span>
            <span className={`settlement-amount ${balance.isOwed ? 'positive' : 'negative'}`}>
              ${Math.abs(balance.balance).toFixed(2)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
});
